import { useEffect, useRef } from "react";

const HOTEL_POS = { lat: 45.77303860, lng: 13.60674540 };
const GMAPS_KEY = "AIzaSyDraq7lbEZU2A3wQ3d79NwuBZGTjMnNtxc";

const MAP_STYLES = [
  { featureType: "landscape", stylers: [{ saturation: -100 }, { lightness: 65 }, { visibility: "on" }] },
  { featureType: "poi", stylers: [{ saturation: -100 }, { lightness: 51 }, { visibility: "simplified" }] },
  { featureType: "road.highway", stylers: [{ saturation: -100 }, { visibility: "simplified" }] },
  { featureType: "road.arterial", stylers: [{ saturation: -100 }, { lightness: 30 }, { visibility: "on" }] },
  { featureType: "road.local", stylers: [{ saturation: -100 }, { lightness: 40 }, { visibility: "on" }] },
  { featureType: "transit", stylers: [{ saturation: -100 }, { visibility: "simplified" }] },
  { featureType: "administrative.province", stylers: [{ visibility: "off" }] },
  { featureType: "administrative.locality", stylers: [{ visibility: "off" }] },
  { featureType: "administrative.neighborhood", stylers: [{ visibility: "on" }] },
  { featureType: "water", elementType: "labels", stylers: [{ visibility: "off" }, { lightness: 0 }, { saturation: 0 }] },
  { featureType: "water", elementType: "geometry", stylers: [{ hue: "#ffffff" }, { lightness: 20 }, { saturation: -97 }] },
];

export default function MapAurora({ height = "65vh" }) {
  const containerRef = useRef(null);
  const mapInstanceRef = useRef(null);

  useEffect(() => {
    let mounted = true;

    function initMap() {
      if (!mounted || !containerRef.current || mapInstanceRef.current) return;

      const G = window.google.maps;
      const myLatLng = new G.LatLng(HOTEL_POS.lat, HOTEL_POS.lng);

      const map = new G.Map(containerRef.current, {
        zoom: 17,
        center: myLatLng,
        styles: MAP_STYLES,
        scrollwheel: false,
        mapTypeControl: false,
        panControl: false,
        zoomControlOptions: {
          style: G.ZoomControlStyle.SMALL,
          position: G.ControlPosition.LEFT_BOTTOM,
        },
      });

      new G.Marker({
        position: myLatLng,
        map: map,
        icon: "/images/marker.png",
      });

      mapInstanceRef.current = map;
    }

    // Se Google Maps è già caricato, inizializza direttamente
    if (window.google && window.google.maps) {
      initMap();
      return () => { mounted = false; };
    }

    // Altrimenti carica lo script
    const scriptId = "gmaps-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GMAPS_KEY}&sensor=false`;
      script.async = true;
      script.defer = true;
      script.onload = initMap;
      document.head.appendChild(script);
    } else {
      // Script già inserito ma in attesa di caricamento
      const waitForGoogle = setInterval(() => {
        if (window.google && window.google.maps) {
          clearInterval(waitForGoogle);
          initMap();
        }
      }, 100);
    }

    return () => { mounted = false; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      ref={containerRef}
      id="map"
      data-testid="location-map"
      style={{ height, width: "100%", position: "relative", zIndex: 0 }}
    />
  );
}
